import { render, staticRenderFns } from "./form-customer.vue?vue&type=template&id=2be8880a&scoped=true"
import script from "./form-customer.vue?vue&type=script&lang=js"
export * from "./form-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8880a",
  null
  
)

export default component.exports